import React, { useState , useContext} from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';
import { AppContext } from '../../context/AppContext';
import { useApiClient } from '../../ApiService/useApiClient';

const CreatePaymentMethod = () => {

  const api = useApiClient();

  const stripe = useStripe();
  const elements = useElements();

const { user , token} = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setLoading(true);

    if (!stripe || !elements) {
      setStatus('Stripe not initialized.');
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      setStatus(error.message);
      setLoading(false);
      return;
    }

    try {

      let baseURL = "api/payments/create-payment-method";
      
      const response = await api.post(baseURL, {
       // tenantId: tenantId,
        paymentMethodId: paymentMethod.id,
      });

      setStatus(`Payment method created and saved! ID: ${response.data.paymentMethodId}`);
    } catch (err) {
      setStatus(`Failed to save payment method: ${err.response?.data || err.message}`);
    }

    setLoading(false);
  };

  return (
    <div>
      <h4>Add Payment Method</h4>
      <form onSubmit={handleSubmit}>
        <CardElement />
        <button type="submit" disabled={!stripe || loading}>
          {loading ? 'Processing...' : 'Save Payment Method'}
        </button>
      </form>
      {status && <div style={{ marginTop: '10px', color: 'red' }}>{status}</div>}
    </div>
  );
};

export default CreatePaymentMethod;
